import React, {useEffect, useState} from "react";
import _ from "i18n";
import {connect} from "react-redux";
import { Row, Col } from 'antd';
import {getPaymentStatistics} from "../../../actions/thunks.js";
import {resetAssignmentsFilters} from "../../../actions/actions.js";
import {formatAmount} from "utils";
import moment from "moment";

const PaymentStatisticsBloc = ({paymentInfos,
  statisticsFilter,
  eventStatsFilter,
  appRef,
  auth,
  getPaymentStatistics,
  resetAssignmentsFilters
}) => {

  const loadPaymentStatistics = () => {
    getPaymentStatistics(statisticsFilter.apps && statisticsFilter.apps.length > 0 ? statisticsFilter.apps : [] , statisticsFilter.appRefs && statisticsFilter.appRefs.length > 0 ? statisticsFilter.appRefs : [], auth.currentClient ? auth.currentClient.id : null, eventStatsFilter.year && eventStatsFilter.year.length > 0 ? eventStatsFilter.year : [], statisticsFilter.appType && statisticsFilter.appType.length > 0 ? statisticsFilter.appType : [])
  }

  useEffect(() => {
   loadPaymentStatistics();
  }, []);

  useEffect(() => {
    loadPaymentStatistics();
  }, [statisticsFilter, eventStatsFilter.year]);
  
  const getEventDates = () => {

    let result = [];

    if(statisticsFilter && statisticsFilter.appRefs && statisticsFilter.appRefs.length >0) {

      statisticsFilter.appRefs.forEach(id => {

        if (appRef && appRef.length > 0) {
          let appRefFilter = appRef.find(item => item.id == id);
          if (appRefFilter) {
            result.push(moment(appRefFilter.eventDate.date).format('YYYY'))
          }
        }
      });
    }

    return result;
  }


    let amoutOgone = paymentInfos && paymentInfos.items && paymentInfos.items['OGONE'] && paymentInfos.items['OGONE'].amount ? paymentInfos.items['OGONE'].amount : 0;
    let amoutVirement = paymentInfos && paymentInfos.items && paymentInfos.items['BANK_TRANSFER'] && paymentInfos.items['BANK_TRANSFER'].amount ? paymentInfos.items['BANK_TRANSFER'].amount : 0;
    let amountManual = paymentInfos && paymentInfos.items && paymentInfos.items['MANUAL'] && paymentInfos.items['MANUAL'].amount ? paymentInfos.items['MANUAL'].amount : 0;
    let amountPayConiq = paymentInfos && paymentInfos.items && paymentInfos.items['PAY_CONIQ'] && paymentInfos.items['PAY_CONIQ'].amount ? paymentInfos.items['PAY_CONIQ'].amount : 0;
    let amountMangoPay = paymentInfos && paymentInfos.items && paymentInfos.items['MANGO_PAY'] && paymentInfos.items['MANGO_PAY'].amount ? paymentInfos.items['MANGO_PAY'].amount : 0;


    const showAssignmentDate = statisticsFilter.year.length > 0 ? `period=[${statisticsFilter.year.join(',')}],` : (getEventDates().length > 0 ? `period=[${getEventDates().join(',')}],` :``);
    const showAppRef = statisticsFilter.appRefs.length > 0 ? `,appRefs=[${statisticsFilter.appRefs.join(',')}]` : ``;

    return (
      <div className="fact-bloc">

        <div className="title">
          {_('Assignments')}
        </div>

        <Row gutter={16}>
          <Col className="gutter-row" span={4} xs={20} sm={12} md={12} xl={4}>
            <div className="gutter-box payment-bloc-background">
              <div className="sub-title-facturation">
                {_('OGONE')}
              </div>
              <div className="line"/>

              <div className="pl-4 mt-10">

                <div className="pl-4  ca-cantainer">
                  <div className="flex items-center justify-center ">
                    <img src={"/img/icons/Ogone-Big.svg"}/>
                  </div>

                  <div className="flex items-center justify-center flex-col ml-8 mt-4">
                    <div className="text-center div-total">
                      TOTAL
                    </div>
                    <div className="text-center div-amount">
                      {paymentInfos && paymentInfos.items && paymentInfos.items['OGONE'] && paymentInfos.items['OGONE'].amount ? formatAmount(paymentInfos.items['OGONE'].amount) : 0}
                    </div>
                  </div>

              </div>
            </div>
            </div>
          </Col>

          <Col className="gutter-row" span={4} xs={20} sm={12} md={12} xl={4}>
            <div className="gutter-box payment-bloc-background">
              <div className="sub-title-facturation">
                {_('Pay Coniq')}
              </div>
              <div className="line"/>

              <div className="pl-4 mt-10">

                <div className="pl-4  ca-cantainer">
                  <div className="flex items-center justify-center ">
                    <img src={"/img/icons/Payconiq-Big.svg"}/>
                  </div>

                  <div className="flex items-center justify-center flex-col ml-8 mt-4">
                    <div className="text-center div-total">
                      TOTAL
                    </div>
                    <div className="text-center div-amount">
                      {paymentInfos && paymentInfos.items && paymentInfos.items['PAY_CONIQ'] && paymentInfos.items['PAY_CONIQ'].amount ? formatAmount(paymentInfos.items['PAY_CONIQ'].amount) : 0}
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </Col>

          <Col className="gutter-row" span={4} xs={20} sm={12} md={12} xl={4}>
            <div className="gutter-box payment-bloc-background">
              <div className="sub-title-facturation">
                {_('Mango Pay')}
              </div>
              <div className="line"/>

              <div className="pl-4 mt-10">

                <div className="pl-4 ca-cantainer">
                  <div className="flex items-center justify-center ">
                    <img src={"/img/icons/mangopay-Big.svg"}/>
                  </div>

                  <div className="flex items-center justify-center flex-col ml-8 mt-4">
                    <div className="text-center div-total">
                      TOTAL
                    </div>
                    <div className="text-center div-amount">
                      {paymentInfos && paymentInfos.items && paymentInfos.items['MANGO_PAY'] && paymentInfos.items['MANGO_PAY'].amount ? formatAmount(paymentInfos.items['MANGO_PAY'].amount) : 0}
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </Col>


          <Col className="gutter-row" span={4} xs={20} sm={12} md={12} xl={4}>
            <div className="gutter-box payment-bloc-background">
              <div className="sub-title-facturation">
                {_('BANK_TRANSFER')}
              </div>
              <div className="line"/>

              <div className="pl-4 mt-10">

                <div className="pl-4 ca-cantainer">
                  <div className="flex items-center justify-center ">
                    <img src={"/img/icons/BANK-TRANSFER.svg"}/>
                  </div>

                  <div className="flex items-center justify-center flex-col ml-8 mt-4">
                    <div className="text-center div-total">
                      TOTAL
                    </div>
                    <div className="text-center div-amount">
                      {paymentInfos && paymentInfos.items && paymentInfos.items['BANK_TRANSFER'] && paymentInfos.items['BANK_TRANSFER'].amount ? formatAmount(paymentInfos.items['BANK_TRANSFER'].amount) : 0}
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </Col>


          <Col className="gutter-row" span={4} xs={20} sm={12} md={12} xl={4}>
            <div className="gutter-box payment-bloc-background">
              <div className="sub-title-facturation">
                {_('MANUAL')}
              </div>
              <div className="line"/>

              <div className="pl-4 mt-10">

                <div className=" pl-4  ca-cantainer">
                  <div className="flex items-center justify-center ">
                    <img src={"/img/icons/MANUAL.svg"}/>
                  </div>

                  <div className="flex items-center justify-center flex-col ml-8 mt-4">
                    <div className="text-center div-total">
                      TOTAL
                    </div>
                    <div className="text-center div-amount">
                      {paymentInfos && paymentInfos.items && paymentInfos.items['MANUAL'] && paymentInfos.items['MANUAL'].amount ? formatAmount(paymentInfos.items['MANUAL'].amount) : 0}
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </Col>

          <Col className="gutter-row" span={4} xs={20} sm={12} md={12} xl={4}>
            <div className="gutter-box payment-bloc-background">
              <div className="sub-title-facturation">
                Total
              </div>
              <div className="line"/>

              <div className="pl-4 mt-10">

                <div className="pl-4 ca-cantainer">
                  <div className="flex items-center justify-center ">
                    <img src={"/img/icons/TOTAL2.svg"}/>
                  </div>

                  <div className="flex items-center justify-center flex-col ml-8 mt-4">
                    <div className="text-center div-total">
                      TOTAL
                    </div>
                    <div className="text-center div-amount">
                      {formatAmount(parseInt(amountManual) + parseInt(amoutVirement)+ parseInt(amoutOgone)+ parseInt(amountMangoPay)+ parseInt(amountPayConiq))}
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </Col>

        </Row>

      </div>);
}

const mapStateToProps = state => ({
  paymentInfos: state.paymentInfos,
  statisticsFilter: state.filters.statisticsFilter,
  eventStatsFilter: state.filters.eventStatsFilter,
  appRef: state.appRefFilter.items,
  auth: state.auth,
});

const mapDispatchToProps = {
  getPaymentStatistics,
  resetAssignmentsFilters
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentStatisticsBloc);



// WEBPACK FOOTER //
// ./app/components/Admin/statisctics/PaymentStatisticsBloc.js